import type { ReactNode } from "react";
import type { RowSteps } from "../../hooks/useRowSteps";
import type { Categorization } from "../../types/transaction";
import { ReviewedTransactionRow } from "../ReviewedTransactionRow";

interface ReviewedSectionProps {
  items: Categorization[];
  /** The list response's ledger_readable: false hides every date label. */
  ledgerReadable: boolean;
  labels: Record<string, string>;
  steps: RowSteps;
}

/** The reviewed rows under the deck, each with its Undo and, when offered, its Redo. */
export function ReviewedSection({
  items,
  ledgerReadable,
  labels,
  steps,
}: ReviewedSectionProps): ReactNode {
  if (items.length === 0) return null;
  return (
    <div className="reviewed-section">
      <h3 className="reviewed-header">Reviewed ({items.length})</h3>
      <div className="reviewed-list">
        {items.map((item) => (
          <ReviewedTransactionRow
            key={item.id}
            item={item}
            ledgerReadable={ledgerReadable}
            isUndoDisabled={steps.isUndoDisabled(item)}
            onUndo={(id) => void steps.undo(id)}
            isRedoDisabled={steps.isRedoDisabled(item)}
            onRedo={(id) => void steps.redo(id)}
            labels={labels}
          />
        ))}
      </div>
    </div>
  );
}
